import { CanvasTexture } from "three";

const RESOLUTION = 512;

export default class Disclaimer {
    constructor(text = '[CLICK] TO START') {
        // this.canvas = document.createElement('canvas');
        // this.canvas.width = RESOLUTION
        // this.canvas.height = RESOLUTION
        // this.canvas.style = 'position: absolute; z-index: 99999; bottom: 0; left: 0; outline: 1px solid red';
        // document.body.appendChild(this.canvas)

        this.text = text;

        this.canvas = new OffscreenCanvas(RESOLUTION, RESOLUTION);
        this.ctx = this.canvas.getContext('2d');

        // Settings
        this.ctx.font = "24px sans-serif";
        this.ctx.fillStyle = '#6666ff';
        this.dimensions = this.ctx.measureText(this.text)
        this.dimensions.height = 24;

        const speed = 100;
        this.speed = {
            x: Math.random() < 0.5 ? -speed : speed,
            y: Math.random() < 0.5 ? -speed : speed
        };

        this.position = {
            x: Math.random() * this.canvas.width,
            y: Math.random() * this.canvas.height
        }

        this.texture = new CanvasTexture(this.canvas);
    }

    render(dt) {
        this.ctx.clearRect(0,0,this.canvas.width, this.canvas.height)

        this.position.x+=this.speed.x * dt;
        this.position.y+=this.speed.y * dt;

        if(this.position.x < 0 && this.speed.x < 0) this.speed.x*=-1;
        if(this.position.x + this.dimensions.width > this.canvas.width && this.speed.x > 0) this.speed.x*=-1;

        if(this.position.y - this.dimensions.height < 0 && this.speed.y < 0) this.speed.y*=-1;
        if(this.position.y + this.dimensions.height > this.canvas.height && this.speed.y > 0) this.speed.y*=-1;

        this.ctx.fillText(this.text, this.position.x, this.position.y);
        this.texture.needsUpdate = true;
    }
}
